import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonObject } from "typedjson";
import { DxGridToolbarButton } from "./dx-grid-toolbar-button";
/** Опции панели инструментов списка. */
let DxGridToolbarOptions = class DxGridToolbarOptions {
    /** Опции панели инструментов списка. */
    constructor() {
        this._buttons = [];
    }
    get buttons() {
        return this._buttons;
    }
    set buttons(value) {
        this._buttons = value;
    }
};
tslib_1.__decorate([
    jsonArrayMember(DxGridToolbarButton, { name: "buttons", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxGridToolbarOptions.prototype, "_buttons", void 0);
DxGridToolbarOptions = tslib_1.__decorate([
    jsonObject
], DxGridToolbarOptions);
export { DxGridToolbarOptions };
